import { AdTypes, CategoryID, FeatureURI } from '@sbt-web/network/types';

const coreApartmentFeatures = [
  FeatureURI.BuildingCondition,
  FeatureURI.Size,
  FeatureURI.Floor,
  FeatureURI.Room,
  FeatureURI.Bathrooms,
  FeatureURI.Parking,
];

const coreVillaFeatures = [
  FeatureURI.BuildingCondition,
  FeatureURI.Size,
  FeatureURI.Room,
  FeatureURI.Bathrooms,
  FeatureURI.Parking,
];

const coreRoomFeatures = [
  FeatureURI.BuildingCondition,
  FeatureURI.RoomType,
  FeatureURI.Floor,
  FeatureURI.Bathrooms,
  FeatureURI.Gender,
  FeatureURI.Smoker,
  FeatureURI.Parking,
  FeatureURI.Cin,
];

const coreOfficeFeatures = [
  FeatureURI.BuildingCondition,
  FeatureURI.OfficeType,
  FeatureURI.Size,
  FeatureURI.Floor,
  FeatureURI.Room,
  FeatureURI.Bathrooms,
  FeatureURI.Parking,
];

const coreVacationHouseFeatures = [
  FeatureURI.BuildingCondition,
  FeatureURI.Size,
  FeatureURI.Floor,
  FeatureURI.Room,
  FeatureURI.Bathrooms,
  FeatureURI.Parking,
  FeatureURI.Cin,
];

const coreFeaturesByCategoryAndType = new Map<string, FeatureURI[]>([
  [`${CategoryID.Appartamenti}_${AdTypes.Sell}`, coreApartmentFeatures],
  [
    `${CategoryID.Appartamenti}_${AdTypes.Rent}`,
    [...coreApartmentFeatures, FeatureURI.Cin],
  ],
  [`${CategoryID.Ville}_${AdTypes.Sell}`, coreVillaFeatures],
  [
    `${CategoryID.Ville}_${AdTypes.Rent}`,
    [...coreVillaFeatures, FeatureURI.Cin],
  ],
  [`${CategoryID.CamerePostiLetto}_${AdTypes.Rent}`, coreRoomFeatures],
  [`${CategoryID.UfficiLocali}_${AdTypes.Sell}`, coreOfficeFeatures],
  [`${CategoryID.UfficiLocali}_${AdTypes.Rent}`, coreOfficeFeatures],
  [
    `${CategoryID.CaseVacanza}_${AdTypes.VacationRent}`,
    coreVacationHouseFeatures,
  ],
]);

const conditionLabel = 'Stato',
  roomTypeLabel = 'Tipologia',
  officeTypeLabel = 'Tipologia',
  sizeLabel = 'Superficie',
  floorLabel = 'Piano',
  roomLabel = 'Locali',
  bathroomsLabel = 'Bagni',
  genderLabel = 'Affittasi a',
  availableNowLabel = 'Disponibilità immediata',
  smokerLabel = 'Camere per fumatori',
  parkingLabel = 'Parcheggio',
  cinLabel = 'CIN';

const coreFeatureLabels = new Map<string, string>([
  [FeatureURI.BuildingCondition, conditionLabel],
  [FeatureURI.RoomType, roomTypeLabel],
  [FeatureURI.OfficeType, officeTypeLabel],
  [FeatureURI.Size, sizeLabel],
  [FeatureURI.Floor, floorLabel],
  [FeatureURI.Room, roomLabel],
  [FeatureURI.Bathrooms, bathroomsLabel],
  [FeatureURI.Gender, genderLabel],
  [FeatureURI.Smoker, smokerLabel],
  [FeatureURI.Parking, parkingLabel],
  [FeatureURI.Cin, cinLabel],
]);

const coreFeatureSortOrder = new Map<string, number>([
  [roomTypeLabel, 0],
  [officeTypeLabel, 1],
  [conditionLabel, 2],
  [sizeLabel, 3],
  [floorLabel, 4],
  [roomLabel, 5],
  [bathroomsLabel, 6],
  [genderLabel, 7],
  [smokerLabel, 8],
  [parkingLabel, 9],
  [cinLabel, 10],
]);

const balconyLabel = 'Balcone',
  gardenLabel = 'Giardino',
  elevatorLabel = 'Ascensore',
  furnishedLabel = 'Arredato',
  receptionLabel = 'Servizio portineria',
  lastFloorLabel = 'Ultimo piano',
  multiLevelLabel = 'Proprietà su più livelli',
  airConLabel = 'Aria condizionata';

const detailFeatureLabels = new Map<string, string>([
  [FeatureURI.Balcony, balconyLabel],
  [FeatureURI.Garden, gardenLabel],
  [FeatureURI.Elevator, elevatorLabel],
  [FeatureURI.Furnished, furnishedLabel],
  [FeatureURI.Reception, receptionLabel],
  [FeatureURI.LastFloor, lastFloorLabel],
  [FeatureURI.MultiLevel, multiLevelLabel],
  [FeatureURI.AvailableNow, availableNowLabel],
  [FeatureURI.AirConditioning, airConLabel],
]);

const detailFeatureSortOrder = new Map<string, number>([
  [balconyLabel, 0],
  [gardenLabel, 1],
  [elevatorLabel, 2],
  [furnishedLabel, 3],
  [receptionLabel, 4],
  [lastFloorLabel, 5],
  [multiLevelLabel, 6],
  [availableNowLabel, 7],
  [airConLabel, 8],
]);

const heatingLabel = 'Riscaldamento',
  energyClassLabel = 'Classe energetica';

const energyFeatureLabels = new Map<string, string>([
  [FeatureURI.Heating, heatingLabel],
  [FeatureURI.EnergyClass, energyClassLabel],
]);

const energyFeatureSortOrder: Map<string, number> = new Map([
  [heatingLabel, 0],
  [energyClassLabel, 1],
]);

export {
  coreFeatureLabels,
  coreFeatureSortOrder,
  detailFeatureLabels,
  detailFeatureSortOrder,
  energyFeatureLabels,
  energyFeatureSortOrder,
  coreFeaturesByCategoryAndType,
};
